import { render, staticRenderFns } from "./CustomerShowContactsTab.vue?vue&type=template&id=2e634d1a"
import script from "./CustomerShowContactsTab.vue?vue&type=script&lang=ts"
export * from "./CustomerShowContactsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports